export const SOCKET_ON_MESSAGE = 'SOCKET_ON_MESSAGE'

export const SOCKET_ACTION_TYPE = {
    NEW_STACK_READY: 'newStackReady',
    APP_COMMUNICATION_READY: 'appCommunicationReady',
    CHANGE_LANGUAGE: 'changeLanguage',
    CHANGE_MODULE: 'changeModule',
    SHOW_MODULE_OUTPUT: 'showModuleOutput',
    REFRESH_GROUPS: 'refreshGroups',
    REFRESH_FAVOURITES: 'refreshFavourites',
    REFRESH_ENTITY_STACK_HISTORY: 'refreshEntityStackHistory',
    CHANGE_ENTITY_STACK_TAB: 'changeEntityStackTab',
    ACTION_REFRESH_GROUP_MONITORING: 'refreshGroupMonitoring',
    SOCKET_SEARCH_RESULTS: 'searchResults',
    PREVENT_DIALOG_OVERLAY: 'preventDialogOverlay',
    CLOSE_TAB: 'closeTab',
    CLOSE_NEW_TAB: 'closeNewTab',
}

export const LOCALE_PREFIX = 'services.socket'
